module.exports = __webpack_public_path__ + "static/media/Art4.4a1c176c.pdf";